import type { TInputType, TLabelPosition } from './types';
import type { InputStateType } from './state';
import type { InputVariantsType } from './variants';
import type { InputSizeType } from './size';

/**
 * Input Theme
 */

export enum InputThemeEnum {
  Light = 'Light',
  Dark = 'Dark',
}

export type InputThemeType = keyof typeof InputThemeEnum;

/**
 * Theming Props
 */

export type InputThemeProps = {
  inputType: TInputType;
  inputState: InputStateType;
  inputVariant: InputVariantsType;
  inputTheme: InputThemeType;
  inputSize: InputSizeType;
  labelPosition: TLabelPosition;
};
